import {ManipulationEditor} from "./ManipulationEditor";
import {Handler} from "./Handler";

export class ResizeLaneHandler extends Handler {

	/**
	 * @param {SwimlaneEditor} parent parent editor
	 * @param {string} horizontalType - "left", "center", "right"
	 * @param {string} verticalType - "top", "middle", "bottom"
	 */
	constructor(parent, horizontalType, verticalType) {
		super(parent);
		this.horizontalType = horizontalType;
		this.verticalType = verticalType;
	}


	get x() {
		switch (this.horizontalType) {
			case "left": return this.parent.left;
			case "center": return this.parent.left + this.parent.coords.w/2;
			case "right": return this.parent.left + this.parent.coords.w;
		}
	}

	get y() {
		switch (this.verticalType) {
			case "top": return this.parent.top;
			case "middle": return this.parent.top + this.parent.coords.h/2;
			case "bottom": return this.parent.top + this.parent.coords.h;
		}
	}

	set x(val) {
		if (this.horizontalType === "left") {
			const dist = val - this.parent.left;
			this.parent.left = val;
			this.parent.coords.w -= dist;
		} else if (this.horizontalType === "right") {
			const dist = val - (this.parent.left+this.parent.coords.w);
			this.parent.coords.w += dist;
		}
	}

	set y(val) {
		if (this.verticalType === "top") {
			const dist = val - this.parent.top;
			this.parent.top = val;
			this.parent.coords.h -= dist;
		} else if (this.verticalType === "bottom") {
			const dist = val - (this.parent.top+this.parent.coords.h);
			this.parent.coords.h += dist;
		}
	}
}